<div class="upload-container">
  <div
    class="upload-dropzone"
    [class.is-dragging]="isDraggingFile"
    (dragenter)="onDragEnter($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <p class="upload-icon" aria-hidden="true">&#8682;</p>
    <h2 class="upload-title">Upload Analysis File</h2>
    <p class="upload-helper">
      Drag and drop your PaScal Analyzer JSON file here
    </p>
    <p class="upload-divider">or</p>
    <label for="file-upload-input" class="upload-action-btn">
      Browse JSON File
    </label>
    <input
      #fileInput
      id="file-upload-input"
      type="file"
      accept="application/json"
      (change)="onFileInputChange($event)"
      class="hidden"
    />

    <p *ngIf="error" class="upload-error">{{ error }}</p>
  </div>
</div>
